import React, { FC } from 'react';
import styled from 'styled-components/macro';
import { Controller } from 'react-hook-form';
import media from 'styles/media';
import * as MESSAGES from 'constants/messages';
import { NO_SELECT_NUMBER } from 'constants/form';
import { ProfileFormItems, ProfileFormControl } from 'types/profile';
import { Selectbox } from 'components/atoms';
import { Field } from 'components/molecules';

type EnglishSkillFormFieldProps = {
  error: string | undefined;
  control: ProfileFormControl<'englishSkillId'>;
  englishSkills: ProfileFormItems['englishSkills'];
};

const StyledSelectbox = styled(Selectbox)`
  width: 368px;

  ${media.mobile} {
    width: 100%;
  }
`;

const EnglishSkillFormField: FC<EnglishSkillFormFieldProps> = props => {
  const { error, control, englishSkills } = props;

  return (
    <Field label={MESSAGES.PROFILE.FIELD.ENGLISH_SKILL.LABEL} required>
      <Controller
        control={control}
        name="englishSkillId"
        render={innerProps => (
          <StyledSelectbox
            value={innerProps.value}
            error={error}
            options={englishSkills}
            aria-label={MESSAGES.PROFILE.FIELD.ENGLISH_SKILL.LABEL}
            onChange={innerProps.onChange}
            onBlur={innerProps.onBlur}
            noSelectValue={NO_SELECT_NUMBER}
          />
        )}
      />
    </Field>
  );
};

export default EnglishSkillFormField;
